/*
 * A small deterrent to casual artwork downloads, not DRM. Anything displayed by
 * a browser can still be captured. Keep normal navigation and customizer input.
 */
(() => {
  'use strict';
  if (window.msArtworkProtectionReady) return;
  window.msArtworkProtectionReady = true;

  const mediaSelector = [
    '[data-ms-gallery] img',
    '[data-ms-zoom-image]',
    '.ms-product-card__image img',
    '.ms-catalog__category img',
    '[data-ms-customizer] img',
    '[data-ms-customizer] canvas',
    '.ms-hero-carousel img',
    '.ms-room-campaign img',
    '.ms-featured-image img',
    '.ms-theme-index-grid img',
    '.ms-collection-book__image img',
    '.ms-menu-feature img',
    '.ms-trends-teaser-image img',
    '[data-ms-comparison-photo] img',
    '.mw-card__media img',
    '.mw-gallery img',
    '.mw-arches__frame img',
    '.mw-lightbox img',
    '.mw-arch img',
    '.mw-tile img'
  ].join(',');

  // These artwork-only surfaces include crop handles and image-hover labels.
  // Their neighbouring captions, forms, gallery controls and page text stay free.
  const artworkSurfaceSelector = [
    '.ms-product-card__image',
    '.ms-featured-image',
    '[data-ms-customizer-layout-art]',
    '[data-ms-customizer-wall]',
    '[data-ms-comparison-photo]',
    '.mw-card__media',
    '.mw-arches__frame'
  ].join(',');

  const protectMedia = root => {
    if (!(root instanceof Element)) return;
    const mark = media => {
      media.setAttribute('draggable', 'false');
      media.setAttribute('data-ms-artwork-protected', '');
    };
    if (root.matches(mediaSelector)) mark(root);
    root.querySelectorAll(mediaSelector).forEach(mark);
  };

  const isArtworkTarget = target => target instanceof Element && (
    target.closest(mediaSelector) || target.closest(artworkSurfaceSelector)
  );

  // Some browsers retarget an image drag to its enclosing product link. Check
  // the actual image area so dragging or selecting the link's caption stays free.
  const isLinkedArtworkDrag = event => {
    const link = event.target instanceof Element && event.target.closest('a');
    if (!link) return false;
    return [...link.querySelectorAll(mediaSelector)].some(media => {
      const bounds = media.getBoundingClientRect();
      return bounds.width > 0 && bounds.height > 0 &&
        event.clientX >= bounds.left && event.clientX <= bounds.right &&
        event.clientY >= bounds.top && event.clientY <= bounds.bottom;
    });
  };

  // Do not consume pointer, touch, click or keyboard events. In particular,
  // preventDefault here must not replace the customizer's pointer-drag logic.
  document.addEventListener('contextmenu', event => {
    if (isArtworkTarget(event.target)) event.preventDefault();
  }, true);
  document.addEventListener('dragstart', event => {
    if (isArtworkTarget(event.target) || isLinkedArtworkDrag(event)) event.preventDefault();
  }, true);

  const initialise = () => {
    protectMedia(document.documentElement);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(protectMedia));
    }).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
